import * as React from 'react';

import {Icon, Popup} from "semantic-ui-react";

import {virtualizedTableId} from "../../VirtualizedTableUtils";
import {IVirtualizedTableCellComponentProps, ISelectFieldValue} from "../../VirtualizedTableInterfaces";

interface PortalDropdownProps extends IVirtualizedTableCellComponentProps {
    width?: number;
    onTriggerClick?:any;
}

interface IPortalDropdownState {
    open: boolean;
    scrollLeft?: number;
}

class PortalDropdown extends React.Component<PortalDropdownProps, IPortalDropdownState> {
    constructor(props: PortalDropdownProps) {
        super(props);
        this.state = {
            open: false
        };
    }

    componentDidMount() {
        document.addEventListener('scroll', this.handleHorizontalScroll, true);
    }

    private handleHorizontalScroll = (e: any) => {
        if (this.state.open && this.state.scrollLeft !== undefined) {
            const optionTableElem = document.getElementById(virtualizedTableId);
            if (optionTableElem && optionTableElem !== null) {
                if (optionTableElem.scrollLeft !== this.state.scrollLeft)
                    this.setState({
                        open: false,
                        scrollLeft: undefined
                    });
            }
        }
    }

    private onChange = (value?: any) => {
        this.props.onChange(value);
    }

    private onTriggerClick = () => {
        const optionTableElem = document.getElementById(virtualizedTableId);
        this.setState({
            open: true,
            scrollLeft: optionTableElem && optionTableElem !== null ? optionTableElem.scrollLeft : undefined
        });
        
        if(this.props.onTriggerClick) {
            this.props.onTriggerClick();
        }
        
    }

    render() {
        const payload: ISelectFieldValue = this.props.value;

        if (!payload || !payload.options || payload.options.length === 0)
            return null;

        const activeValue = payload.options.find(opt => opt.value === payload.value);

        return (
            <Popup
                content={(
                    !this.props.readOnly && <div style={{ width: this.props.width ? this.props.width : "auto" }}>
                        {
                            payload.options.map((opt, index) => {
                                return (
                                    <div
                                        className={`portal-dropdown-option ${payload.value === opt.value ? 'portal-dropdown-active-option' : ''}`}
                                        key={index}
                                        onClick={() => this.onChange({ ...payload, value: opt.value})}
                                    >
                                        {opt.text}
                                    </div>
                                );
                            })
                        }
                    </div>
                )}
                trigger={
                    <div
                        className={`portal-dropdown-input ${ this.props.readOnly ? 'portal-dropdown-input-disabled'
                            : this.state.open ? 'portal-dropdown-input-active' : 'portal-dropdown-input-default'}`}
                        onClick={this.onTriggerClick}
                    >
                        <Icon name='dropdown'/>
                        <span className='portal-dropdown-input-value'>
                            {activeValue ? activeValue.text : ''}
                        </span>
                    </div>
                }
                on='click'
                open={this.state.open}
                onClose={() => this.setState({open: false})}
                position='bottom center'
                basic={true}
                className='portal-dropdown-portal-container'
            />
        );
    }
}

export default PortalDropdown;



// WEBPACK FOOTER //
// ./src/components/Table/components/dropdowns/PortalDropdown.tsx